module.exports = __webpack_public_path__ + "assets/img/soft1.262066bc.jpg";